<template>
  <section class="container">
    <!-- ======= TextEditor Section ======= -->

    <!-- End TextEditor -->

    <div class="col-sm-6">
      <div class="profile">
        <h4>پروفایل کاربری</h4>
        <hr />
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon1"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;نام</span
          >
          <input
            type="text"
            class="form-control"
            v-model="firstname"
            aria-label="firstname"
            aria-describedby="basic-addon1"
            required
          />
        </div>

        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon1">نام خانوادگی</span>
          <input
            type="text"
            class="form-control"
            v-model="lastname"
            aria-label="lastname"
            aria-describedby="basic-addon1"
            required
          />
        </div>

        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon1"
            >تاریخ تولد&nbsp;&nbsp;&nbsp;&nbsp;</span
          >
          <input
            type="text"
            class="form-control"
            placeholder="1368/08/17"
            v-model="birthdate"
            aria-label="birthdate"
            aria-describedby="basic-addon1"
            required
          />
        </div>

        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            id="inlineRadio1"
            value="1"
          />
          <label class="form-check-label" for="inlineRadio1">مرد</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            id="inlineRadio2"
            value="2"
          />
          <label class="form-check-label" for="inlineRadio2">زن</label>
        </div>
        <div class="d-flex justify-content-end">
          <button @click="save()" type="button" class="btn appointment-btn">
            <i class="bi bi-save"></i> ذخیره
          </button>
        </div>
      </div>
    </div>
    <br />
    <div class="col-sm-6 Mobile">
      <h4>تغییر موبایل</h4>
      <hr />

      <div class="col input-group mb-3">
        <span class="input-group-text" id="basic-addon1"
          >&nbsp;&nbsp;&nbsp;&nbsp;شماره موبایل</span
        >
        <input
          disabled
          type="text"
          class="form-control ltr"
          placeholder=""
          v-model="currentMobile"
        />
      </div>

      <div class="col input-group mb-3">
        <span class="input-group-text" id="basic-addon1">
          شماره موبایل جدید</span
        >
        <input
          type="text"
          class="form-control ltr"
          @input="checkMobile"
          placeholder=""
          v-model="mobile"
          aria-label="Username"
          aria-describedby="basic-addon1"
          required
        />
        <button @click="recieveCode()" type="button" class="btn btn-warning">
          <i class="bi bi-save"></i> دریافت کد
        </button>
      </div>

      <div class="col input-group mb-3">
        <span class="input-group-text" id="basic-addon1">کد دریافت شده</span>
        <input
          type="text"
          class="form-control ltr"
          placeholder=""
          v-model="smsCode"
          aria-label="smsCode"
          aria-describedby="basic-addon1"
          required
        />
      </div>
      <div class="d-flex justify-content-end">
        <button
          @click="changeMobile()"
          type="button"
          class="btn appointment-btn"
        >
          <i class="bi bi-save"></i> ذخیره
        </button>
      </div>
    </div>

    <div class="col-sm-6 Mobile">
      <h4>تغییر ایمیل</h4>
      <hr />

      <div class="col input-group mb-3">
        <span class="input-group-text" id="basic-addon1"
          >&nbsp;&nbsp;&nbsp;&nbsp;ایمیل</span
        >
        <input
          disabled
          type="text"
          class="form-control ltr"
          placeholder=""
          v-model="currentEmail"
        />
      </div>

      <div class="col input-group mb-3">
        <span class="input-group-text" id="basic-addon1"> ایمیل جدید</span>
        <input
          type="text"
          class="form-control ltr"
          @input="checkMobile"
          placeholder=""
          v-model="email"
          aria-label="Username"
          aria-describedby="basic-addon1"
          required
        />
        <button @click="recieveCode()" type="button" class="btn btn-warning">
          <i class="bi bi-save"></i> دریافت کد
        </button>
      </div>

      <div class="col input-group mb-3">
        <span class="input-group-text" id="basic-addon1">کد دریافت شده</span>
        <input
          type="text"
          class="form-control ltr"
          placeholder=""
          v-model="emailCode"
          aria-label="emailCode"
          aria-describedby="basic-addon1"
          required
        />
      </div>
      <div class="d-flex justify-content-end">
        <button
          @click="changeEmail()"
          type="button"
          class="btn appointment-btn"
        >
          <i class="bi bi-save"></i> ذخیره
        </button>
      </div>
    </div>

    <div class="col-sm-6"></div>
   
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
export default {
  components: {
    Swal,
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
    }),
  },
  data() {
    return {
      user: null,
      firstname: null,
      lastname: null,
      birthdate: null,
      gender: null,
      mobile: null,
      smsCode: null,
      emailCode: null,
      currentMobile: null,
      currentEmail: null,
    };
  },
  watch: {
    currentUser() {
      if (this.currentUser != undefined) {
        this.loadData();
      }
    },
  },
  methods: {
   
    recieveCode() {
      if (commonMethod.Ismobile(this.mobile)) {
        this.$store.dispatch("sendCode", { mobileNumber: this.mobile });
        Swal.fire("موفق", "کد به شماره موبایل وارد شده ارسال گردید", "success");
      } else if (commonMethod.IsEmail(this.email)) {
        this.$store.dispatch("sendCode", { mobileNumber: this.email });
        Swal.fire("موفق", "کد به ایمیل وارد شده ارسال گردید", "success");
      }
    },
    checkMobile(e) {
      var result =
        commonMethod.Ismobile(this.mobile) || commonMethod.IsEmail(this.email);
      if (result) {
        e.currentTarget.classList.remove("is-invalid");
        e.currentTarget.classList.add("is-valid");
      } else {
        e.currentTarget.classList.add("is-invalid");
      }
    },
    changeMobile() {
      this.$store.dispatch("changeMobile", {
        mobileNumber: this.mobile,
        code: this.smsCode,
      });
      setTimeout(() => {
        this.loadData();
      }, 2000);
    },
    changeEmail() {
      this.$store.dispatch("changeMobile", {
        mobileNumber: this.email,
        code: this.emailCode,
      });
      setTimeout(() => {
        this.loadData();
      }, 2000);
    },
    save() {
      var _gender =
        document.getElementById("inlineRadio1").checked == true ? 1 : 2;
      this.$store.dispatch("saveUserInfo", {
        firstname: this.firstname,
        lastname: this.lastname,
        birthdate: this.birthdate,
        gender: _gender,
      });
    },
    loadData() {
      this.user = this.$store.state.currentUser;
      this.firstname = this.user.firstname;
      this.lastname = this.user.lastname;
      this.birthdate = this.user.birthDate;
      this.gender = this.user.gender;
      this.currentMobile = this.user.mobile;
      this.currentEmail = this.user.email;
      if (this.gender == 1) {
        document.getElementById("inlineRadio1").checked = true;
      } else {
        document.getElementById("inlineRadio2").checked = true;
      }
    },
  },
  mounted() {},
};
</script>


<style scoped>
section {
  padding: 140px 0 !important;
}
</style>